import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarInventory(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="Inventory"?"":"Inventory")} title="Inventory" className={props.activeMenu == "Inventory" ? "sidenav-expanded-active pointer px-0 sidenavbar-text" : "pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("inventory:inventory:view")?false:true}>
                <i className="fa fa-cube sidenavbar-icon px-3"></i>
                <span className="mx-3 sidenavbar-text">Inventory
                    <i className={showMenu=="Inventory"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "Inventory" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/inventory/containersummary")} title="Container Summary" 
                className={props.activeSubMenu == "ContainerSummary" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("inventory:container:view")?false:true}>
                    <span className="mx-3">Container Summary</span>
                </a>
            </ul>
            <ul className={showMenu == "Inventory" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/inventory/container")} title="Cargo Name"
                className={props.activeSubMenu == "Container" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("inventory:container:view")?false:true}>
                    <span className="mx-3">Containers</span>
                </a>
            </ul>
        </>
    );
}

export default SideNavBarInventory;
